import { FC, useMemo } from "react";
import { CellProps, Column } from "react-table";
import { Center } from "@chakra-ui/react";
import { EditIcon, ViewIcon } from "@chakra-ui/icons";
import { primaryColor } from "../../../utils/colors";
import TableComponent from "../../../components/organism/Table/TableComponent";
import { useNavigate } from "react-router-dom";
import IndicatorManagementState from "../components/IndicatorManagementState";
import { AuthUser } from "../../../types/User/AuthUser";

interface TableIndicatorManagementProps {
  dataTable: any[];
  isLoaded: boolean;
  setValue: (key: string, value: any) => void;
  openModal: (newTitle: string, newButtonTitle: string) => void;
  user: AuthUser;
}

const TableIndicatorManagement: FC<TableIndicatorManagementProps> = ({
  dataTable,
  isLoaded,
  setValue,
  openModal,
  user,
}) => {
  const navigate = useNavigate();
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Indicador", accessor: "name" },
      { Header: "Parceiro", accessor: "partner.name" },
      { Header: "Frequência de recolha", accessor: "frequency.name" },
      { Header: "Integração", accessor: "collectionType.name" },
      { Header: "Nível", accessor: "level.name" },
      {
        Header: "Estado",
        accessor: "state",
        Cell: ({ value }: any) => {
          return (
            value && (
              <IndicatorManagementState
                stateValue={value}
                additionalStyle={{ display: "inline-block" }}
              />
            )
          );
        },
      },
      {
        Header: "Ver Detalhes",
        accessor: "ver",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center>
            <ViewIcon
              color={primaryColor}
              boxSize={6}
              cursor="pointer"
              onClick={() => {
                openModal(`Ver detalhes | ${row.original.name}`, "Fechar");
                setValue("row", row.original);
              }}
            />
          </Center>
        ),
      },
    ];
    if (user?.permissions && user.permissions.includes("EditIndicators")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        width: 2,
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                navigate(`/gestao-de-indicadores/${row.original.id}`, {
                  state: { edit_indicator: row.original },
                });
              }}
            />
          </Center>
        ),
      });
    }

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, navigate, openModal, dataTable]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "ver", hasShadow: true }, { value: "edit" }]}
    />
  );
};

export default TableIndicatorManagement;
